import { createContext } from "react";
import { useScheduleForCancellation } from "src/hooks/useScheduleForCancellation";

export type CancellationModalValue = ReturnType<
  typeof useScheduleForCancellation
>;

export const CancellationModalContext =
  createContext<CancellationModalValue | null>(null);

interface Props {
  children: React.ReactNode;
  subscriptionId: number;
}

const CancellationModalProvider = ({ children, subscriptionId }: Props) => {
  const value = useScheduleForCancellation(subscriptionId);
  return (
    <CancellationModalContext.Provider value={value}>
      {children}
    </CancellationModalContext.Provider>
  );
};

export default CancellationModalProvider;
